import React from 'react';
import ImageHolderBox from './ImageHolderBox';
//import { NavLink } from 'react-router-dom';

const ResearchItems = ({ item }) => {
	const picList = item.authors.map((authors, index) => (
		<ImageHolderBox author={authors} key={index} />
	));

	return (
		<div className='card'>
			<div className='img-holder'>{picList}</div>
			<div className='card-body'>
				<h5 className='card-title align-middle'>{item.title}</h5>
				<div className='publisher-name'>{item.publisher}</div>
				<p className='card-text'>{item.abstract}</p>
				<div className='d-flex  flex-wrap justify-content-between'>
					{item.url !== '' && (
						<a
							href={item.url}
							target='_new'
							className='btn-sm btn-primary text-decoration-none publisher-button'
						>
							View at publisher
						</a>
					)}

					{item.researchGate !== '' && (
						<a
							href={item.researchGate}
							target='_new'
							className='fab fa-researchgate researchgate text-decoration-none'
						></a>
					)}
				</div>
			</div>
		</div>
	);
};

export default ResearchItems;
